import CardDropdown from 'components/common/CardDropdown';
import Flex from 'components/common/Flex';
import { getSize } from 'helpers/utils';
import React from 'react';
import { Dropdown, Row } from 'react-bootstrap';
import cloudUpload from 'assets/img/icons/cloud-upload.svg';
import { useDropzone } from 'react-dropzone';
import PropTypes from 'prop-types';

function UploadMultiImages({ file, setFile, handleRemove }) {
  const { getRootProps, getInputProps } = useDropzone({
    accept: {
      'image/*': ['.jpeg', '.png', '.jpg'],
      'application/pdf': ['.pdf'],
      'application/msword': ['.doc'],
      'application/vnd.openxmlformats-officedocument.wordprocessingml.document':
        ['.docx']
    },
    onDrop: acceptedFiles => {
      setFile([
        ...file,
        ...acceptedFiles.map(file =>
          Object.assign(file, {
            preview: URL.createObjectURL(file)
          })
        )
      ]);
    }
  });

  return (
    <Row>
      <div
        {...getRootProps({
          className: `border py-5 rounded`
        })}
      >
        <input name="uploadedFiles" {...getInputProps()} />
        <Flex justifyContent="center">
          <img src={cloudUpload} alt="" width={25} className="me-2" />
          <p className="fs-9 mb-0 text-700">Drop your images here</p>
        </Flex>
      </div>
      <div>
        {file.map(file => (
          <Flex
            alignItems="center"
            className="py-3 border-bottom btn-reveal-trigger"
            key={file.path}
          >
            <img
              className="rounded"
              width={40}
              height={40}
              src={file.preview}
              alt={file.path}
            />

            <Flex
              justifyContent="between"
              alignItems="center"
              className="ms-3 flex-1"
            >
              <div>
                <h6>{file.path}</h6>
                <Flex className="position-relative" alignItems="center">
                  <p className="mb-0 fs-10 text-400 line-height-1">
                    <strong>{getSize(file.size)}</strong>
                  </p>
                </Flex>
              </div>
            </Flex>
            <CardDropdown>
              <div className="py-2">
                <Dropdown.Item
                  className="text-danger"
                  onClick={() => handleRemove(file.path)}
                >
                  Remove
                </Dropdown.Item>
              </div>
            </CardDropdown>
          </Flex>
        ))}
      </div>
    </Row>
  );
}

UploadMultiImages.propTypes = {
  file: PropTypes.any,
  setFile: PropTypes.any,
  handleRemove: PropTypes.any
};

export default UploadMultiImages;
